export default __webpack_public_path__ + "static/united-black-5dc14b1221ba58367f215cb6d8b33cf3.svg";